module.exports = __webpack_public_path__ + "static/media/bg.1cf5b30c.jpg";